module.exports = __webpack_public_path__ + "img/menu_video_blu@3x.e9d64310.png";